const INTERVALS = [0, 1, 3, 7, 14, 30, 60, 90, 180, 365];

export function advance(card, remembered) {
  let step = card.step ?? 0;
  step = remembered ? Math.min(step + 1, INTERVALS.length - 1) : 0;
  const nextReview = new Date();
  nextReview.setDate(nextReview.getDate() + INTERVALS[step]);
  return { step, nextReview: nextReview.toISOString() };
}

export function isDue(card) {
  if (!card.nextReview) return true;
  return new Date(card.nextReview) <= new Date();
}

export function getDueCards(cards) {
  return cards.filter(isDue);
}
